import { useState } from 'react';

const faqs = [
  {
    q: '51黑料吃瓜网是什么类型的平台？',
    a: '51黑料吃瓜网是专注娱乐八卦与网络热点的一站式资讯聚合平台，每日从全网精选明星动态、网红八卦、影视综艺、社会热点等优质黑料吃瓜内容，通过51吃瓜官网全网最新入口实时更新。',
  },
  {
    q: '51黑料吃瓜网站最新地址在哪里可以获取？',
    a: '本页面即为51黑料吃瓜网官方入口，您可以将当前网址收藏保存。同时建议关注我们的移动端入口和社交媒体账号，获取黑料吃瓜最新地址的动态更新通知，确保访问不迷路。',
  },
  {
    q: '平台的内容更新频率是怎样的？',
    a: '51吃瓜官网全网最新内容保持7×24小时不间断更新，每天新增200+条最新爆料。我们的编辑团队全天候监控全网热点，确保用户在吃瓜网站首页第一时间获取最新鲜的黑料吃瓜内容。',
  },
  {
    q: '如何向平台投稿或提供爆料线索？',
    a: '我们非常欢迎用户投稿爆料！您可以通过页面中的投稿爆料入口联系我们的编辑团队，51黑料吃瓜网承诺保护爆料人隐私，所有投稿信息将严格保密处理，优质爆料可获得首页推荐。',
  },
  {
    q: '51吃瓜最新地址变更后如何通知用户？',
    a: '建议您将本页面加入浏览器收藏夹，或通过移动端入口下载我们的快捷访问方式。此外，关注51黑料吃瓜网的社交媒体账号可以第一时间收到51吃瓜网站入口变更通知，确保访问体验不受影响。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于51黑料吃瓜网你关心的都在这里</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                  <i
                    className={`text-lg text-foreground-400 transition-transform duration-300 ${
                      openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-48 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}